import * as AppConstants from "../utils/constants/AppConstants";
import * as axios from "axios";

/*
 * Метод /login вызывается в трёх вариантах — по email с паролем,
 * по токену и при восстановлении пароля. Платформа и версия
 * нужны во всех, поэтому добавляются здесь, а не в каждом месте
 * сборки параметров.
 */
const withLoginMeta = params => {
    const loginParams = params || new URLSearchParams()

    loginParams.set('platform', AppConstants.PLATFORM)
    loginParams.set('version', AppConstants.APP_VER_NUMBER)

    return loginParams
}

export const LoginApi = {
    doLogin(params) {
        return (
            axios
                .post(AppConstants.LOGIN_URL_PATH, withLoginMeta(params))
                .then(response => {
                        return response.data
                    }
                )
        )
    },
    doLoginTelegram(params) {
        return (
            axios
                .post(AppConstants.LOGIN_URL_PATH, withLoginMeta(params))
                .then(response => {
                        return response.data
                    }
                )
        )
    },
    doLoginWithToken(params) {
        return (
            axios
                .post(AppConstants.LOGIN_URL_PATH, withLoginMeta(params))
                .then(response => {
                        return response.data
                    }
                )
        )
    },
    doRegister(params) {
        return (
            axios
                .post(AppConstants.REGISTER_PATH, withLoginMeta(params))
                .then(response => {
                        return response.data
                    }
                )
        )
    },
    doRestore(params) {
        return (
            axios
                .post(AppConstants.RECOVERY_PASSWORD_PATH, withLoginMeta(params))
                .then(response => {
                        return response.data
                    }
                )
        )
    }
}
